<template>
  <nav class="app-bottom-nav" aria-label="Основная навигация">
    <router-link
      v-if="auth.isAuth && productAccessOk"
      to="/search"
      class="app-bottom-nav__item"
      active-class="app-bottom-nav__item--active"
    >
      <i class="fa-solid fa-magnifying-glass" aria-hidden="true" />
      <span>Поиск</span>
    </router-link>
    <router-link
      v-if="auth.isAuth && productAccessOk"
      to="/lists"
      class="app-bottom-nav__item"
      active-class="app-bottom-nav__item--active"
    >
      <i class="fa-solid fa-table-columns" aria-hidden="true" />
      <span>Списки</span>
    </router-link>
    <button
      v-if="auth.isAuth"
      type="button"
      class="app-bottom-nav__item"
      @click="$emit('open-feedback')"
    >
      <i class="fa-solid fa-comment-dots" aria-hidden="true" />
      <span>Связь</span>
    </button>
    <router-link
      v-if="auth.isAuth && auth.user?.is_staff"
      to="/admin/dashboard"
      class="app-bottom-nav__item"
      active-class="app-bottom-nav__item--active"
    >
      <i class="fa-solid fa-gauge-high" aria-hidden="true" />
      <span>Админ</span>
    </router-link>
    <button
      v-if="auth.isAuth"
      type="button"
      class="app-bottom-nav__item"
      :class="{ 'app-bottom-nav__item--active': cabinetActive }"
      @click="$emit('open-cabinet')"
    >
      <i class="fa-regular fa-user-circle" aria-hidden="true" />
      <span>Кабинет</span>
    </button>
    <button
      v-if="!auth.isAuth"
      type="button"
      class="app-bottom-nav__item"
      @click="$router.push('/login')"
    >
      <i class="fa-solid fa-right-to-bracket" aria-hidden="true" />
      <span>Вход</span>
    </button>
    <button
      v-else
      type="button"
      class="app-bottom-nav__item"
      @click="auth.logout()"
    >
      <i class="fa-solid fa-right-from-bracket" aria-hidden="true" />
      <span>Выход</span>
    </button>
  </nav>
</template>

<script setup>
import { useAuthStore } from '@/store/pinia.js'
import { canUseProduct } from '@/utils/productAccess.js'
import { computed } from 'vue'

defineProps({
  cabinetActive: { type: Boolean, default: false },
})

defineEmits(['open-cabinet', 'open-feedback'])

const auth = useAuthStore()
const productAccessOk = computed(() => canUseProduct(auth.user))
</script>

<style scoped>
.app-bottom-nav {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1030;
  height: calc(var(--app-bottom-nav-h) + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: #fff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -4px 16px rgba(15, 23, 42, 0.06);
}

@media (max-width: 991.98px) {
  .app-bottom-nav {
    display: flex;
    align-items: stretch;
    justify-content: space-around;
  }
}

.app-bottom-nav__item {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  min-height: var(--app-bottom-nav-h);
  padding: 0.35rem 0.25rem;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 0.65rem;
  font-weight: 500;
  text-decoration: none;
  line-height: 1.1;
  cursor: pointer;
}

.app-bottom-nav__item i {
  font-size: 1.1rem;
}

.app-bottom-nav__item--active {
  color: #1161ee;
}
</style>
